export const ARTISTS_VIEW_TEST_ID = 'artists_view_test_id';

export const ANIMATION_DURATION = 500;

export enum ARTIST_POSITION_TYPE {
  ABSOLUTE = 'absolute',
  RELATIVE = 'relative',
}
